module.exports = __webpack_public_path__ + "img/jf2.afcf35d8.png";